<template>
  <div class="panel-body">
    <form>
      <v-overlay :value="isSending" absolute>
        <v-progress-circular v-if="isSending" :size="36" color="primary" indeterminate></v-progress-circular>
      </v-overlay>
      <v-row>
        <v-col>
          <v-checkbox v-if="broadcastVisible" v-model="broadcast" label="Broadcast"></v-checkbox>
        </v-col>
        <v-col>
          <v-select
            v-model="selectTemplate"
            :items="templates"
            item-text="name"
            item-value="notification"
            label="Templates"
            persistent-hint
            return-object
            single-line
            @change="populateFromTemplate"
          ></v-select>
        </v-col>
      </v-row>
      <v-select
        v-model="selectedGroups"
        v-if="!broadcast"
        :items="groups"
        :item-text="item => item.id +' - '+ item.name"
        label="Groups"
        required="!broadcast"
        :disabled="this.users !== null"
        multiple
        presistent-hint
        return-object
        @change="selectGroup"
      ></v-select>
      <v-container ma-0 pa-0>
        <v-textarea
          rows="1"
          v-if="!broadcast"
          clearable
          v-model="ids"
          label="User Id"
          required="!broadcast"
          @click:clear= "selectedGroups = []"
          :readonly="this.users !== null || this.loadingGroupIds == true || this.selectedGroupIds.length != 0"
          :loading="this.loadingGroupIds == true"
        ></v-textarea>
      </v-container>
      <!-- :error-messages="idsErrors" -->
      <!-- type="number" -->
      <!-- @input="$v.ids.$touch()"
      @blur="$v.ids.$touch()"-->
      <v-text-field
        v-model="title"
        :error-messages="titleErrors"
        :counter="20"
        label="Title"
        required
        @input="$v.title.$touch()"
        @blur="$v.title.$touch()"
      ></v-text-field>
      <v-textarea
        v-model="message"
        :error-messages="messageErrors"
        :counter="50"
        label="Message"
        required
        @input="$v.message.$touch()"
        @blur="$v.message.$touch()"
      ></v-textarea>
      <v-textarea
        v-model="auditMessage"
        :error-messages="auditMessageErrors"
        :counter="300"
        label="In App Message"
        required
        @input="$v.auditMessage.$touch()"
        @blur="$v.auditMessage.$touch()"
      ></v-textarea>
      <v-select
        v-model="notType"
        :error-messages="notTypeErrors"
        :items="types"
        label="Type"
        required
        @change="$v.notType.$touch()"
        @blur="$v.notType.$touch()"
      ></v-select>
      <v-btn v-if="submitVisible" :disabled="$v.$invalid" @click="submit">submit</v-btn>
      <v-btn @click="clear">clear</v-btn>
    </form>
    <pre class="messages">{{ this.history }}</pre>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    users: {
      type: Array,
      required: false,
      default: null
    },
    broadcastVisible: {
      required: false,
      default: true
    },
    submitVisible: {
      required: false,
      default: true
    },
    sendConfirmation: {
      required: false,
      default: true
    }
  },
  mixins: [validationMixin],
  validations: {
    // ids: { maxLength: maxLength(100) },
    title: { required, maxLength: maxLength(100) },
    message: { required, maxLength: maxLength(300) },
    auditMessage: { required, maxLength: maxLength(300) },
    notType: { required }
  },
  data: () => ({
    history: '',
    isSending: false,
    broadcast: false,
    ids: [],
    title: '',
    message: '',
    auditMessage: '',
    email: '',
    notType: null,
    groups: [],
    loadingGroups: false,
    loadingGroupIds: false,
    selectedGroupIds: [],
    selectedGroups: [],
    autoGrowHack: false,
    types: [
      'challenge',
      'contest',
      'fitness',
      'gift',
      'jar',
      'reward',
      'sport',
      'support',
      'system',
      'transaction',
      'user',
      'winner'
    ],
    selectTemplate: null,
    templates: [
      {
        name: '52 Week Challenge',
        notification: {
          title: 'Congratulations!',
          message: 'You just won the 52 week challenge!',
          auditMessage:
            'Way to go! You just completed the 52 week challenge and have won $20 towards your next saving goal!',
          type: 'winner'
        }
      },
      {
        name: 'Jar Filling',
        notification: {
          title: 'Jar Filling',
          message: 'XXXX was just added to your jar!',
          auditMessage: 'XXXX was just added to your XXXX jar!',
          type: 'jar'
        }
      },
      {
        name: 'Survey Winner',
        notification: {
          title: 'Congratulations!',
          message: 'You just won $25 for completing our survey',
          auditMessage:
            'Thank you for participating in our survey. You just won $25 towards one of your savings jars!',
          type: 'winner'
        }
      },
      {
        name: 'Weekly Prize',
        notification: {
          title: 'Congratulations!',
          message: 'You just won $250 towards one of your goals',
          auditMessage:
            'Way to go! You just won the Weekly Save to Win prize of $250 towards one of your goals.',
          type: 'winner'
        }
      },
      {
        name: 'QUBER System Test',
        notification: {
          title: 'QUBER System Test',
          message: 'Testing the QUBER broadcast system',
          auditMessage:
            'This is a message used for testing the QUBER broadcast notification system, please ignore.',
          type: 'support'
        }
      }
    ]
  }),
  computed: {
    // idsErrors () {
    //   const errors = []
    //   if (!this.$v.ids.$dirty) return errors
    //   !this.$v.ids.required && errors.push('IDs are required')
    //   return errors
    // },
    notTypeErrors () {
      const errors = []
      if (!this.$v.notType.$dirty) return errors
      !this.$v.notType.required && errors.push('Type is required')
      return errors
    },
    titleErrors () {
      const errors = []
      if (!this.$v.title.$dirty) return errors
      !this.$v.title.maxLength &&
        errors.push('Title must be at most 100 characters long')
      !this.$v.title.required && errors.push('Title is required.')
      return errors
    },
    messageErrors () {
      const errors = []
      if (!this.$v.message.$dirty) return errors
      !this.$v.message.maxLength &&
        errors.push('Message must be at most 300 characters long')
      !this.$v.message.required && errors.push('Message is required.')
      return errors
    },
    auditMessageErrors () {
      const errors = []
      if (!this.$v.auditMessage.$dirty) return errors
      !this.$v.auditMessage.maxLength &&
        errors.push('Audit Message must be at most 300 characters long')
      !this.$v.auditMessage.required &&
        errors.push('Audit Message is required.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      return errors
    }
  },
  watch: {
    users: {
      immediate: true,
      deep: true,
      type: Array,
      handler (newValue, oldValue) {
        if (this.users) {
          this.ids = ''
          this.users.forEach(user => {
            if (user.userId) {
              this.setIds(user.userId)
            }
          })
        } else {
          this.clear()
        }
      }
    }
  },
  created () {
    this.laodGroups()
  },
  methods: {
    setIds (myIds) {
      if (this.ids === undefined || this.ids === null || this.ids.length === 0) {
        this.ids = String(myIds)
      } else {
        this.ids = String(this.ids + ',' + myIds)
      }
    },
    populateFromTemplate (temp) {
      this.title = temp.notification.title
      this.message = temp.notification.message
      this.auditMessage = temp.notification.auditMessage
      this.notType = temp.notification.type
    },
    async submit () {
      this.$v.$touch()
      this.isSending = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_NOTIFICATION}/notifications`

      var body = {
        type: this.notType,
        message: this.message,
        title: this.title,
        data: {
          'audit-message': this.auditMessage
        }
      }

      var postResponse = null

      if (!this.broadcast && (this.ids === undefined || this.ids === null || this.ids.length < 1)) {
        alert('No users have been selected for this non broadcast message. Please either set the users to receive this message or explicitely set it as a broadcast message.')
        this.isSending = false
        return
      } else if (!this.broadcast) {
        body.userIds = this.ids.split(',').map(Number)
      } else if (this.broadcast && this.ids !== undefined && this.ids !== null && this.ids.length > 0) {
        alert('You have selected to send a broadcast notification but also specified users, please correct this and retry')
        this.isSending = false
        return
      } else {
        if (!confirm('This message will be sent to all active QUBER users, do you wish to proceed?')) {
          this.isSending = false
          return
        } else {
          endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/broadcastNotification?allUsers=true`
        }
      }

      postResponse = await rh.default.post(endpoint, body, true).catch(e => {
        this.errors.push(e)
      }).finally(() => { this.isSending = false })

      if (postResponse === null) {
        this.history = 'An error occured sending notification'
      } else if (postResponse.status === 200) {
        if (this.sendConfirmation) {
          alert('Notification Successfully Sent!')
        }
        this.history = postResponse.status + postResponse.statusText
      } else {
        alert('Failed Sending Notification')
        this.history = postResponse.status + postResponse.statusText
      }
      // this.clear()
    },
    clear () {
      this.$v.$reset()
      if (!this.users) {
        this.ids = ''
      }
      this.title = ''
      this.notType = ''
      this.message = ''
      this.auditMessage = ''
      this.email = ''
      this.broadcast = false
      this.selectTemplate = null
    },
    async laodGroups () {
      this.groups = []

      this.loadingGroups = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (
        getResponse !== undefined &&
        getResponse.data !== undefined &&
        getResponse.data.length > 0
      ) {
        this.groups = getResponse.data
      }
      this.loadingGroups = false
    },
    async selectGroup () {
      this.ids = []
      this.selectedGroupIds = this.selectedGroups.map(i => i.id)

      if (this.selectedGroupIds === undefined || this.selectedGroupIds === null || this.selectedGroupIds.length < 1) {
        this.selectedGroupIds = []
        return
      }
      // If there's a selected group id
      if (this.selectedGroups.length !== 0) {
        var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups/users-from-groups?groupids=${this.selectedGroupIds}`

        var getResponse = await rh.default.get(endpoint, true).catch(e => {
          this.errors.push(e)
        })
        if (
          getResponse !== undefined &&
          getResponse.data !== undefined &&
          getResponse.data.length > 0
        ) {
          this.ids = getResponse.data.join()
        }
      } else {
        // Set null to enable userIds textarea again
        this.selectedGroupIds = []
      }
    }
  }
}
</script>
<style>
.inputIds input[type="number"] {
  -moz-appearance: textfield;
}
.inputIds input::-webkit-outer-spin-button,
.inputIds input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
